import React from "react";
import { Link } from "gatsby";
import cx from "classnames";

import resource from "~/models/resource";

type Props = {
  resource: resource;
  className?: string;
};

function ResourceCard({ resource, className }: Props) {
  return (
    <div className={cx(className, "flex items-stretch flex-col gap-4 mb-0")}>
      <Link
        aria-label={resource.title}
        to={resource.url.pathname}
        className="block rounded-lg overflow-hidden isolate bg-neutral-99">
        {resource.image && (
          <img
            src={resource.imageUrls?.thumbnail?.publicURL}
            alt={resource.title}
            className="transition-all ease-in-out duration-500 hover:opacity-[0.85] hover:scale-[1.005]"
            loading="eager"
          />
        )}
      </Link>

      <Link
        aria-label={resource.title}
        to={resource.url.pathname}
        className="block mb-3 font-bold leading-[1.4] hover:underlined-link ">
        {resource.title}
      </Link>
    </div>
  );
}

export default ResourceCard;
